import type { SessionUtilisateur } from '../../../api/types.js';
import { estConfinee } from '../../../auth/confinement.js';
import { galerieALaction, galerieAModule } from '../../../auth/sujet.js';
import { surChangementCompte, surOubliIdentite } from '../../../auth/identite.js';
import { purgerInteretsPresentation, type PorteeFile } from '../../stand/fileHorsLigne.js';
import { magasinPresentationCache } from './magasinCache.js';
import { magasinPresentationIndexedDb } from './magasinIndexedDb.js';
import type { MagasinPresentation, PreparationPresentation } from './magasin.js';

export function magasinsPresentation(): MagasinPresentation[] {
  const magasins: MagasinPresentation[] = [];
  if (typeof indexedDB !== 'undefined') magasins.push(magasinPresentationIndexedDb());
  if (typeof caches !== 'undefined') magasins.push(magasinPresentationCache());
  return magasins;
}
export function magasinDeLaGalerie(session: SessionUtilisateur, slug: string): MagasinPresentation {
  const galerie = session.galeries.find((candidate) => candidate.slug === slug);
  if (
    !galerie ||
    !galerieAModule(galerie, 'rendez-vous-client') ||
    !galerieALaction(galerie, 'presentation:read')
  )
    throw new Error('Présentation non autorisée.');
  if (galerieAModule(galerie, 'application-hors-ligne')) return magasinPresentationIndexedDb();
  return magasinPresentationCache();
}
export async function listerPreparations(portee: PorteeFile): Promise<PreparationPresentation[]> {
  return (
    await Promise.all(magasinsPresentation().map((magasin) => magasin.lister(portee)))
  ).flat();
}
export async function harmoniserPresentations(
  session: SessionUtilisateur,
  slug: string | null,
  droitsChanges: boolean,
  precedente?: SessionUtilisateur,
): Promise<void> {
  for (const magasin of magasinsPresentation()) {
    for (const galerie of [
      ...session.galeries,
      ...(precedente?.galeries.filter(
        (ancienne) => !session.galeries.some((courante) => courante.slug === ancienne.slug),
      ) ?? []),
    ]) {
      if (!galerie.slug) continue;
      const ancienne = precedente?.galeries.find((candidate) => candidate.slug === galerie.slug);
      const autorisationChangee =
        ancienne &&
        JSON.stringify([ancienne.actions, ancienne.modules]) !==
          JSON.stringify([galerie.actions, galerie.modules]);
      if (
        autorisationChangee ||
        !session.galeries.some((courante) => courante.slug === galerie.slug) ||
        estConfinee(session) ||
        !galerieAModule(galerie, 'rendez-vous-client') ||
        !galerieALaction(galerie, 'presentation:read') ||
        (droitsChanges && galerie.slug === slug)
      ) {
        const portee = { compteId: session.compte.id, galerieSlug: galerie.slug };
        await magasin.effacerPortee(portee);
        purgerInteretsPresentation(portee);
      }
    }
  }
}
export async function purgerPresentations(): Promise<void> {
  purgerInteretsPresentation();
  await Promise.all(magasinsPresentation().map((magasin) => magasin.toutEffacer()));
}
surOubliIdentite(async ({ localeSeulement }) => {
  if (!localeSeulement) await purgerPresentations();
});
surChangementCompte(purgerPresentations);
